import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "min", "max", "defaultValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { invoke } from '../../../../internal/utils';
import { formatDateValueToHTML } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var NativeTimeInput = /*#__PURE__*/React.forwardRef(function NativeTimeInput(props, ref) {
  var value = props.value,
    min = props.min,
    max = props.max,
    defaultValue = props.defaultValue,
    rest = _objectWithoutProperties(props, _excluded);
  var formatValue = formatDateValueToHTML(value || defaultValue);
  var handleChange = function handleChange(e) {
    invoke(props.onChange, e.currentTarget.value);
  };
  return /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    type: "time",
    defaultValue: formatValue,
    onChange: handleChange,
    min: min,
    max: max
  }));
});